import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[clickPreview]'
})
export class ClickPreviewDirective {
  @Input() clickPreview: string = '';
  constructor() { }

  @HostListener('click', ['$event']) 
  onClick(event: any) {
    event.preventDefault();
    window.open(this.clickPreview);
  }
}